/*
 * @Author: Dong
 * @Date: 2022-04-08 15:22:41
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-17 13:18:43
 */
import React from 'react';

import styles from './index.less';
import Icon from 'root/components/Icon';
import classnames from 'classnames';

interface PropsType {
  logs?: [];
  err?: string;
  catalog?: string;
}

const LogsDetail = (props: PropsType) => {
  const { logs, err, catalog } = props;

  const classname = classnames(styles.detailList, {
    [styles.system]: catalog === 'system',
    [styles.taskItem]: catalog === 'taskItem',
  });

  return (
    <ul className={classname}>
      {logs?.map((item: any) => {
        return item.status !== 'RUNNING' ? (
          item.status === 'SUCCESS' ? (
            <li key={item.text}>
              <Icon type="right16" className={styles.logsIcon} />
              {item.process}
            </li>
          ) : (
            <li key={item.text} className={styles.failLogTxt}>
              {item.process}: {err}
            </li>
          )
        ) : null;
      })}
    </ul>
  );
};

export default LogsDetail;
